import { User } from "@robe/core-types/user";
import { LoginError, resolveLoginErrorParams } from "../errors/LoginError";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export interface LoginParams {
  email: string;
  password: string;
  twoFactorCode?: string;
  remember?: boolean;
}

/**
 * @throws {LoginError}
 */
export const loginRequest = (core: XcoreCore, params: LoginParams): BaseApiRequest<User> =>
  core
    .fetch("/api/login", {
      method: "POST",
      body: JSON.stringify(params),
    })
    .then((res) => res.json())
    .catch((err) => {
      const loginError = resolveLoginErrorParams(err);
      if (loginError) {
        throw new LoginError(loginError);
      }

      throw err;
    });
